<template>
  <v-container class="pa-0 ma-0 about-page">
    <h1 class="show-title mb-10">{{ content.title }}</h1>
    <!-- <div v-html="content.text1"></div> -->
    <div class="d-flex flex-row flex-wrap justify-space-between">
      <!-- TEAM 1 -->
      <div class="col-12 col-sm-6 col-md-3 pa-0 px-3 pb-5">
        <v-card
          class="team-card card-wrapper d-flex flex-column justify-end"
          tile
          flat
        >
          <v-img
            src="@/assets/images/entrypages/Isabel_Rocha.jpg"
            height="300"
          ></v-img>
          <div class="card-caption lightgray">
            <v-card-title class="card-title">ISABEL ROCHA</v-card-title>
            <v-card-title class="card-sub-title darkgray--text py-0"
              >Pro-Rector for Entrepreneurship, and Social and Economic Value
              Creation</v-card-title
            >
          </div>
        </v-card>
      </div>
      <!-- TEAM 2 -->
      <div class="col-12 col-sm-6 col-md-3 pa-0 px-3 pb-5">
        <v-card
          class="team-card card-wrapper d-flex flex-column justify-end"
          tile
          flat
        >
          <v-img
            height="300"
            src="@/assets/images/entrypages/Helder_Lopes.png"
          ></v-img>
          <div class="card-caption lightgray">
            <v-card-title class="card-title">HÉLDER LOPES</v-card-title>
            <v-card-title class="card-sub-title darkgray--text py-0"
              >Director, NOVA Impact (helder.lopes@unl.pt)
            </v-card-title>
          </div>
        </v-card>
      </div>
      <!-- TEAM 3 -->
      <div class="col-12 col-sm-6 col-md-3 pa-0 px-3 pb-5">
        <v-card
          class="team-card card-wrapper d-flex flex-column justify-end"
          tile
          flat
        >
          <v-img
            height="300"
            src="@/assets/images/entrypages/Carla_Portela.jpeg"
          ></v-img>
          <div class="card-caption lightgray">
            <v-card-title class="card-title">CARLA PORTELA</v-card-title>
            <v-card-title class="card-sub-title darkgray--text py-0"
              >Entrepreneurship, Program Manager (carla.portela@unl.pt)
            </v-card-title>
          </div>
        </v-card>
      </div>
      <!-- TEAM 4 -->
      <div class="col-12 col-sm-6 col-md-3 pa-0 px-3 pb-5">
        <v-card
          class="team-card card-wrapper d-flex flex-column justify-end"
          tile
          flat
        >
          <v-img
            height="300"
            src="@/assets/images/entrypages/NunoArantesOliveira.jpg"
          ></v-img>
          <div class="card-caption lightgray">
            <v-card-title class="card-title"
              >NUNO ARANTES-OLIVEIRA</v-card-title
            >
            <v-card-title class="card-sub-title darkgray--text py-0"
              >Knowledge Transfer Advisor (nuno@arantes-oliveira.org)
            </v-card-title>
          </div>
        </v-card>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'Team',
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.team-card {
  border: 1px solid #878a8c !important;
  height: 500px;

  .card-caption {
    height: 160px;
    .card-title {
      font-family: $heading-font-family;
      font-weight: bold;
      font-size: 16px;
      line-height: 21px;
      text-transform: uppercase;
      overflow-wrap: normal;
      word-break: normal;
    }
    .card-sub-title {
      font-family: $heading-font-family;
      font-size: 14px;
      line-height: 18px;
      color: #272727 !important;

      overflow-wrap: normal;
      word-break: normal;
    }
  }
}
</style>
